import { render, staticRenderFns } from "./AnswersType.vue?vue&type=template&id=1d2bb102&scoped=true"
import script from "./AnswersType.vue?vue&type=script&lang=js"
export * from "./AnswersType.vue?vue&type=script&lang=js"
import style0 from "./AnswersType.vue?vue&type=style&index=0&id=1d2bb102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2bb102",
  null
  
)

export default component.exports